import { cn } from '@latitude/token-utils';

import type { SVGProps } from '../../types';

export const CreateVaultIllustration = (props: SVGProps) => {
  const { className, ...restProps } = props;

  return (
    <svg
      className={cn('text-color-ref-primary-primary-50', className)}
      viewBox="0 0 134 98"
      fill="none"
      data-testid="create-vault-illustration"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <g clipPath="url(#clip0_5780_371431)">
        <path
          d="M8.39062 29.2398V26.1445H78.9075V84.4341H8.39062V82.3637V29.2398Z"
          fill="black"
          stroke="white"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M23.4787 84.4883H16.332V87.1394H23.4787V84.4883Z"
          fill="black"
          stroke="white"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M70.0178 84.4883H62.8711V87.1394H70.0178V84.4883Z"
          fill="black"
          stroke="white"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M72.206 31.668H15.0898V78.4579H72.206V31.668Z"
          fill="black"
          stroke="white"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M93.5153 56.9141H88.0234V96.7593H93.6066"
          stroke="white"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M101.593 51.1731C109.271 51.1731 115.495 45.6568 115.495 38.8522C115.495 32.0475 109.271 26.5312 101.593 26.5312C93.9155 26.5312 87.6914 32.0475 87.6914 38.8522C87.6914 45.6568 93.9155 51.1731 101.593 51.1731Z"
          fill="currentColor"
        />
        <path
          d="M89.9922 44.4551C89.9922 44.4551 92.357 42.7479 97.1885 42.1094C97.1885 42.1094 95.8521 45.2301 99.6812 47.8488C99.6812 47.8488 100.543 46.3683 101.594 46.2549C101.594 46.2549 99.5716 46.3289 99.214 44.1197"
          stroke="black"
          strokeWidth="1.03911"
          strokeLinejoin="round"
        />
        <path
          d="M113.197 44.4541C113.197 44.4541 111.073 42.7885 106.241 42.1523C106.241 42.1523 107.337 45.2291 103.511 47.8478C103.511 47.8478 102.65 46.3673 101.598 46.2539C101.598 46.2539 103.547 46.4482 103.908 44.239"
          stroke="black"
          strokeWidth="1.03911"
          strokeLinejoin="round"
        />
        <path
          d="M101.145 50.057V46.3672"
          stroke="black"
          strokeWidth="1.03911"
          strokeLinejoin="round"
        />
        <path
          d="M106.939 35.2337C106.939 35.2337 107.033 32.8556 105.822 31.2755C104.61 29.6955 103.754 29.9708 103.042 29.9708C102.329 29.9708 99.8338 30.2554 99.3118 29.1172C99.3118 29.1172 97.6021 29.2444 97.529 31.7058C97.529 31.7058 97.268 32.5687 96.9104 33.0522C96.5528 33.5357 96.6259 35.6848 96.6259 35.6848C96.6259 35.6848 96.545 38.986 96.6572 40.0825C96.8269 41.7504 97.6465 45.0539 101.851 44.9498C106.056 44.8434 106.863 40.9292 106.96 39.8326C107.054 38.7384 106.936 35.2314 106.936 35.2314L106.939 35.2337Z"
          fill="white"
        />
        <path
          d="M97.2807 35.2171C97.2807 35.2171 96.9962 40.0613 98.899 40.7391C98.899 40.7391 99.7734 40.9334 100.058 40.2348C100.342 39.5362 101.128 39.5177 101.347 39.5177H102.331C102.331 39.5177 103.25 39.5177 103.511 40.177C103.775 40.8363 104.365 40.7391 104.451 40.7391C104.537 40.7391 106.155 40.3135 106.265 38.1412C106.375 35.9713 106.309 35.2333 106.309 35.2333C106.309 35.2333 104.822 33.8384 104.801 32.6562C104.801 32.6562 99.4445 33.4497 98.6563 32.7534C98.6563 32.7534 97.9359 35.0205 97.2781 35.2148L97.2807 35.2171Z"
          fill="black"
        />
        <path
          d="M99.4656 37.8857C100.269 37.8857 100.919 37.3088 100.919 36.5971C100.919 35.8855 100.269 35.3086 99.4656 35.3086C98.6626 35.3086 98.0117 35.8855 98.0117 36.5971C98.0117 37.3088 98.6626 37.8857 99.4656 37.8857Z"
          stroke="white"
          strokeWidth="1.03911"
          strokeLinejoin="round"
        />
        <path
          d="M103.786 37.8857C104.589 37.8857 105.24 37.3088 105.24 36.5971C105.24 35.8855 104.589 35.3086 103.786 35.3086C102.983 35.3086 102.332 35.8855 102.332 36.5971C102.332 37.3088 102.983 37.8857 103.786 37.8857Z"
          stroke="white"
          strokeWidth="1.03911"
          strokeLinejoin="round"
        />
        <path
          d="M100.855 36.3846C100.855 36.3846 101.714 35.8294 102.341 36.4216"
          stroke="white"
          strokeWidth="1.03911"
          strokeLinejoin="round"
        />
        <path
          d="M102.16 38.6437H101.285V36.2031"
          stroke="white"
          strokeWidth="1.03911"
          strokeLinejoin="round"
        />
        <path
          d="M101.238 40.1953H102.332C102.332 40.1953 101.873 41.2803 101.238 40.1953Z"
          stroke="black"
          strokeWidth="1.03911"
          strokeLinejoin="round"
        />
        <path
          d="M132.167 30.8672H119.199"
          stroke="currentColor"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M132.404 34.9062H119.199"
          stroke="currentColor"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M131.519 38.7188H119.199"
          stroke="white"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M133.566 42.5312H119.199"
          stroke="white"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M130.835 46.3398H119.199"
          stroke="white"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M125.622 60.6836H121.91L123.729 62.4255L125.622 60.6836Z"
          stroke="white"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M107.227 45.9513C107.227 45.9513 122.849 45.4285 123.778 60.7707"
          stroke="white"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M72.2138 50.125H15.0977V59.6676H72.2138V50.125Z"
          fill="black"
          stroke="white"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M31.8472 70.1992H0.433594"
          stroke="currentColor"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M25.2654 71.9054C26.4518 71.9054 27.4136 71.053 27.4136 70.0015C27.4136 68.9501 26.4518 68.0977 25.2654 68.0977C24.079 68.0977 23.1172 68.9501 23.1172 70.0015C23.1172 71.053 24.079 71.9054 25.2654 71.9054Z"
          fill="white"
          stroke="white"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M106.498 70.9297H93.0586V82.8411H106.498V70.9297Z"
          fill="white"
        />
        <path
          d="M92.8438 87.1719H116.004"
          stroke="currentColor"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M92.8438 89.3438H116.004"
          stroke="currentColor"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M92.8438 91.5117H116.004"
          stroke="currentColor"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M92.8438 93.6836H116.004"
          stroke="currentColor"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M92.8438 95.8594H116.004"
          stroke="currentColor"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M95.4773 66.6023C96.5887 66.6023 97.4898 65.8038 97.4898 64.8187C97.4898 63.8337 96.5887 63.0352 95.4773 63.0352C94.3658 63.0352 93.4648 63.8337 93.4648 64.8187C93.4648 65.8038 94.3658 66.6023 95.4773 66.6023Z"
          fill="white"
        />
        <path
          d="M101.79 66.6023C102.901 66.6023 103.802 65.8038 103.802 64.8187C103.802 63.8337 102.901 63.0352 101.79 63.0352C100.678 63.0352 99.7773 63.8337 99.7773 64.8187C99.7773 65.8038 100.678 66.6023 101.79 66.6023Z"
          fill="white"
        />
        <path
          d="M108.106 66.6023C109.218 66.6023 110.119 65.8038 110.119 64.8187C110.119 63.8337 109.218 63.0352 108.106 63.0352C106.995 63.0352 106.094 63.8337 106.094 64.8187C106.094 65.8038 106.995 66.6023 108.106 66.6023Z"
          fill="white"
        />
        <path
          d="M103.85 23.9402L78.7402 6.52299L32.6625 6.90932L27.7553 0.78125H5.125C5.125 0.78125 16.7325 22.4898 33.7483 26.2397H70.1552C70.7791 25.2172 69.4583 23.6117 66.9447 23.0542C65.8771 22.7812 64.6243 22.5522 63.1599 22.4042C55.3894 21.6199 53.7163 20.4864 53.7163 20.4864C53.7163 20.4864 66.6576 18.1962 70.1552 16.3802L74.71 23.0727C75.065 23.9587 78.0511 29.5039 84.48 29.3211L80.3141 19.6929L85.5501 25.4347L85.5423 25.4393C85.5423 25.4393 89.9666 31.2759 96.5938 29.3465L94.1533 26.478H94.6284L91.4753 22.543C91.4753 22.543 98.2696 27.6509 103.848 23.9402H103.85Z"
          fill="white"
        />
        <path
          d="M31.7891 16.3711C31.7891 16.3711 38.8653 25.0184 53.7147 20.4842C53.7147 20.4842 67.6322 17.8586 70.1536 16.378"
          stroke="black"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M74.5938 6.16797L85.2277 29.9122"
          stroke="black"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M81.4531 11.1133L94.6294 26.4763"
          stroke="black"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
        <path
          d="M101.781 25.3832C101.781 25.3832 96.266 22.2671 98.2132 19.8242"
          stroke="black"
          strokeWidth="2.07823"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_5780_371431">
          <rect
            width="133.133"
            height="96.4414"
            fill="white"
            transform="translate(0.433594 0.78125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
